module.exports = __webpack_public_path__ + "static/media/4250.582b381d.jpg";